export default function initReveal() {
  const elements = document.querySelectorAll('[data-reveal]')
  if (!elements.length) return

  const io = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return
      const delay = parseInt(entry.target.dataset.revealDelay || 0, 10)
      setTimeout(() => entry.target.classList.add('is-visible'), delay)
      io.unobserve(entry.target)
    })
  }, { threshold: 0.15, rootMargin: '0px 0px -80px 0px' })

  elements.forEach((el) => io.observe(el))
}
